import React from "react";
import { Routes, Route } from "react-router-dom";
import MainScreenComponent from "../components/MainScreen/MainScreenComponent";
import Screens from "../screens/Screens/Screens";
import PDFPage from "../UsefulCompoments/MyDocument";

const AppRoutes = () => {

  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainScreenComponent>
            <Screens.HomePage />
          </MainScreenComponent>
        }
      />
      <Route
        path="/:stageId"
        element={
          <MainScreenComponent>
            <Screens.StageDetails />
          </MainScreenComponent>
        }
      />
      <Route
        path="/blogs"
        element={
          <MainScreenComponent title="Blogs">
            <Screens.Blogs />
          </MainScreenComponent>
        }
      />
      <Route
        path="/blog/:blogId"
        element={
          <MainScreenComponent title="Blog">
            <Screens.IndividualBlog />
          </MainScreenComponent>
        }
      />
      {/* <Route
        path="/:stageId?"
        element={
          <Screen title="Valley Stage">
            <Screens.ValleyStageDetails />
          </Screen>
        }
      /> */}
      {/* <Route
        path="/:stageId?"
        element={
          <Screen title="Growth Stage">
            <Screens.GrowthStageDetails />
          </Screen>
        }
      /> */}
      <Route
        path="/contact-us"
        element={
          <MainScreenComponent title="Contact Us">
            <Screens.ContactUs />
          </MainScreenComponent>
        }
      />
      <Route
        path="/evaluation"
        element={
          <MainScreenComponent title="Contact Us">
            <Screens.Evaluation />
          </MainScreenComponent>
        }
      />
      <Route
        path="/about-us"
        element={
          <MainScreenComponent title="About Us">
            <Screens.AboutUs />
          </MainScreenComponent>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <MainScreenComponent title="Privacy Policy">
            <Screens.PrivacyPolicy />
          </MainScreenComponent>
        }
      />
      <Route
        path="/videos"
        element={
          <MainScreenComponent title="Videos">
            <Screens.Video />
          </MainScreenComponent>
        }
      />
      <Route
        path="/videos/:videoId"
        element={
          <MainScreenComponent title="Videos">
            <Screens.IndividualVideo />
          </MainScreenComponent>
        }
      />
      <Route
        path="/offerings"
        element={
          <MainScreenComponent title="Offerings">
            <Screens.Offerings />
          </MainScreenComponent>
        }
      />
      <Route
        path="/success-stories"
        element={
          <MainScreenComponent title="SuccessStories">
            <Screens.SuccessStories />
          </MainScreenComponent>
        }
      />
      <Route
        path="/pdf"
        element={
          <PDFPage  />
        }
      />
      <Route
        path="*"
        element={
          <MainScreenComponent title="Not Found">
            <Screens.NotFound />
          </MainScreenComponent>
        }
      />
      {/* Add other routes here */}
    </Routes>
  );
};

export default AppRoutes;
